import Logger from '@core/util/universal-logger';
import AddToListController from '../add-to-list/AddToListController';
import Properties from '../util/Properties';

export function onAddToListClick(ctaData) {
  const addToListController = new AddToListController(ctaData);
  addToListController.fireAddToListCall();
}

export function onAddToListSuccess({
  listData,
  productModel,
  productState,
}) {
  import(/* webpackChunkName: 'add-to-list-interstitial' */ '@component/add-to-list-interstitial')
    .then(({ default: AddToListInterstitial }) => {
      const product = JSON.parse(JSON.stringify(productModel.get('product')));
      if (product.detail.flags.chanel) {
        product.detail.name = product.detail.pdfEmailDescription;
      }
      // eslint-disable-next-line no-new
      new AddToListInterstitial({
        data: {
          lists: listData,
          product,
          productState: JSON.parse(JSON.stringify(productState)),
        },
        assetsHost: product.urlTemplate.product,
        responsiveBagNewUrlKS: Properties.get('responsiveBagNewUrlEnabled'),
      });
    })
    .catch(Logger.error);
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/listeners/AddToListListeners.js